/*
 *  (c) 2015 - 2021 ENISCO by FORCAM GmbH
 */
import {SvgIcon, SvgIconProps} from '@mui/material'
import React from 'react'

export function DefaultGroupIcon(props: SvgIconProps) {
  return (
    <SvgIcon color={'primary'} {...props} viewBox='0 0 32 32'>
      <path d='M26,6v7H13V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h9V15H28V6a2,2,0,0,0-2-2Z' />
      <path d='M26,17v9H17v2h9a2.15,2.15,0,0,0,2-2V17Z' />
    </SvgIcon>
  )
}
